/* Stamp existing Shopify compositions with their registered Blade identities. */
(() => {
  const mappings = [
    ['sf-button-primary','.button:not(.button--secondary):not(.button--tertiary),.shopify-payment-button__button--unbranded'],
    ['sf-button-secondary','.button--secondary,.sf-category'],['sf-button-icon','.header__icon,.slider-button,.drawer__close,.modal__close-button,.search__button,.reset__button,.newsletter-form__button,.thumbnail,.product__media-toggle,.deferred-media__poster,.product-media-modal__toggle,.quantity__button,cart-remove-button .button'],
    ['sf-field-text','input:not([type=checkbox]):not([type=radio]):not([type=hidden]):not([type=submit]),textarea'],
    ['sf-select-single','select,.localization-selector'],['sf-button-quiet','.menu-drawer__close-button,.mobile-facets__close-button,.predictive-search__item--term'],['sf-choice-checkbox','input[type=checkbox]'],['sf-choice-radio','input[type=radio]'],['sf-dialog-form','.drawer__inner'],['sf-badge-soft','.badge,.sf-simulator,.sf-store-badge'],
    ['sf-product-card','.product-card-wrapper'],['sf-product-gallery','media-gallery'],['sf-icon-feature-row','.sf-store-story-features li']
  ];
  function initialise(root=document) {
    for (const [component,selector] of mappings) for (const el of root.querySelectorAll(selector)) {
      if (!el.dataset.bladeComponent) { el.dataset.bladeComponent=component;el.dataset.bladeRevision='1.6'; }
    }
    for(const paragraph of root.querySelectorAll('.sf-features--purchase p')) {
      if (!paragraph.textContent.replace(/\u00a0/g, '').trim() && !paragraph.querySelector('img,video,a,input')) paragraph.hidden = true;
    }
    compactFeatures(root);
    setupCampaigns(root);
    setupProductAutoplay(root);
    setupEditorialGalleries(root);
  }
  function setupEditorialGalleries(root) {
    for (const gallery of root.querySelectorAll('[data-sf-editorial-gallery]')) {
      if (gallery.dataset.ready) continue;
      gallery.dataset.ready = 'true';
      const slides = [...gallery.querySelectorAll('[data-sf-gallery-slide]')];
      const controls = gallery.querySelector('[data-sf-gallery-controls]');
      const status = gallery.querySelector('[data-sf-gallery-status]');
      if (!slides.length) continue;
      const thumbnails = document.createElement('div'); thumbnails.className = 'sf-gallery-thumbnails';
      thumbnails.setAttribute('role', 'group'); thumbnails.setAttribute('aria-label', 'Choose an image');
      const buttons = slides.map((slide, i) => {
        const button = document.createElement('button'); button.type = 'button'; button.className = 'sf-gallery-thumb';
        button.dataset.sfGalleryIndex = String(i); button.dataset.bladeComponent = 'sf-button-icon'; button.dataset.bladeRevision = '1.6';
        button.setAttribute('aria-label', `Show image ${i + 1}`);
        const original = slide.querySelector('img');
        if (original) { const image = document.createElement('img'); const url = new URL(original.src, location.href); url.searchParams.set('width', '176'); image.src = url.href; image.alt = ''; image.width = 80; image.height = 52; image.loading = 'lazy'; button.append(image); }
        thumbnails.append(button); return button;
      });
      if (slides.length > 1) gallery.append(thumbnails);
      let index = 0;
      const show = next => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => slide.hidden = i !== index);
        buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        if (buttons[index]) thumbnails.scrollTo({left: Math.max(0, buttons[index].offsetLeft - thumbnails.offsetLeft - thumbnails.clientWidth / 2), behavior: 'auto'});
        status.textContent = `Image ${index + 1} of ${slides.length}`;
      };
      controls.hidden = slides.length < 2;
      gallery.addEventListener('click', event => {
        const step = event.target.closest('[data-sf-gallery-step]');
        if (step) show(index + Number(step.dataset.sfGalleryStep));
        const thumbnail = event.target.closest('[data-sf-gallery-index]');
        if (thumbnail) show(Number(thumbnail.dataset.sfGalleryIndex));
      });
      gallery.addEventListener('keydown', event => {
        if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1)); }
        if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); show(event.key === 'Home' ? 0 : slides.length - 1); }
      });
      show(0);
    }
  }
  function compactFeatures(root){
    for(const content of root.querySelectorAll('.sf-features .metafield-rich_text_field')){
      if(content.dataset.sfCondensed)continue;
      const nodes=[...content.children].filter(n=>n.textContent.trim());const groups=[];
      for(let i=0;i<nodes.length;i+=2){const title=nodes[i],copy=nodes[i+1];const strong=title.querySelector('strong');if(!copy||copy.tagName!=='P'||!( /^H[1-6]$/.test(title.tagName)||(strong&&strong.textContent.trim()===title.textContent.trim()))){groups.length=0;break;}groups.push([title,copy]);}
      if(!groups.length)continue;const template=content.closest('.sf-features').querySelector('[data-sf-feature-icon]');
      const fragment=document.createDocumentFragment();for(const [title,copy] of groups){const row=document.createElement('div');row.className='sf-store-feature';row.dataset.bladeComponent='sf-icon-feature-row';row.dataset.bladeRevision='1.6';if(template)row.append(template.content.cloneNode(true));const text=document.createElement('div');text.append(title.cloneNode(true));if(content.closest('.sf-features--purchase')){const list=document.createElement('ul');const item=document.createElement('li');item.append(copy.cloneNode(true));list.append(item);text.append(list);}else text.append(copy.cloneNode(true));row.append(text);fragment.append(row);}content.replaceChildren(fragment);content.classList.add('sf-store-feature-grid');content.dataset.sfCondensed='true';
    }
  }
  const reducedMotion=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
  function startMutedMedia(media,allowExternal=false){
    if(!media||reducedMotion()||navigator.connection?.saveData||document.hidden||window.Shopify?.designMode)return;
    const template=media.querySelector('template');if(!template)return;
    const video=template.content.querySelector('video');if(video){video.muted=true;video.setAttribute('muted','');video.setAttribute('playsinline','');}
    // Product autoplay is explicitly enabled by the merchant; campaigns retain their existing behaviour.
    const frame=template.content.querySelector('iframe');
    if(frame){
      if(!allowExternal)return;
      try{
        const url=new URL(frame.src);
        if(!['https://www.youtube-nocookie.com','https://player.vimeo.com'].includes(url.origin))return;
        url.searchParams.set('autoplay','1');url.searchParams.set('mute','1');url.searchParams.set('muted','1');
        url.searchParams.set('playsinline','1');url.searchParams.set('controls','1');
        if(url.origin==='https://www.youtube-nocookie.com')url.searchParams.set('enablejsapi','1');
        frame.src=url.toString();
      }catch(_){return;}
    }
    document.querySelectorAll('video').forEach(other=>{if(!media.contains(other))other.pause();});
    media.loadContent?.(false);
    const activeVideo=media.querySelector('video');if(activeVideo){activeVideo.muted=true;activeVideo.play().catch(()=>{});}
    const activeFrame=media.querySelector('iframe');if(activeFrame){const origin=new URL(activeFrame.src).origin;if(origin==='https://www.youtube-nocookie.com'){activeFrame.contentWindow?.postMessage(JSON.stringify({event:'command',func:'mute',args:[]}),origin);activeFrame.contentWindow?.postMessage(JSON.stringify({event:'command',func:'playVideo',args:[]}),origin);}if(origin==='https://player.vimeo.com'){activeFrame.contentWindow?.postMessage(JSON.stringify({method:'setVolume',value:0}),origin);activeFrame.contentWindow?.postMessage(JSON.stringify({method:'play'}),origin);}}

  }
  function pauseMedia(root){for(const video of root.querySelectorAll('video'))video.pause();for(const frame of root.querySelectorAll('iframe')){try{const origin=new URL(frame.src).origin;if(origin==='https://www.youtube-nocookie.com')frame.contentWindow?.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]} ),origin);if(origin==='https://player.vimeo.com')frame.contentWindow?.postMessage(JSON.stringify({method:'pause'}),origin);}catch(_){}}}
  function setupCampaigns(root) {
    for (const campaign of root.querySelectorAll('[data-sf-campaign]')) {
      if (campaign.dataset.sfInitialised) continue;
      campaign.dataset.sfInitialised = 'true';
      const slides = [...campaign.querySelectorAll('[data-sf-campaign-slide]')];
      if (!slides.length) continue;
      let index = 0, paused = false, visible = false, timer;
      const status = campaign.querySelector('[data-sf-campaign-status]');
      const dots = [...campaign.querySelectorAll('[data-sf-campaign-index]')];
      const toggle = campaign.querySelector('[data-sf-campaign-pause]');
      const interval = Math.max(6, Number(campaign.dataset.rotateSeconds) || 8) * 1000;
      const canRotate = () => campaign.dataset.autoRotate === 'true' && slides.length > 1
        && visible && !paused && !reducedMotion() && !document.hidden
        && !campaign.matches(':hover,:focus-within');
      const play = () => {
        if (visible && !document.hidden && !reducedMotion() && campaign.dataset.videoAutoplay === 'true') {
          startMutedMedia(slides[index].querySelector('[data-sf-campaign-video]'));
        }
      };
      const schedule = () => {
        clearTimeout(timer);
        if (canRotate()) timer = setTimeout(() => {
          if (!campaign.isConnected) { observer.disconnect(); return; }
          if (canRotate()) show(index + 1);
          else schedule();
        }, interval);
      };
      const show = (next, manual = false) => {
        pauseMedia(campaign);
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.hidden = false;
          slide.classList.toggle('is-active', i === index);
          slide.inert = i !== index;
          slide.setAttribute('aria-hidden', String(i !== index));
        });
        dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
        if (status) {
          status.setAttribute('aria-live', manual ? 'polite' : 'off');
          status.textContent = `Product ${index + 1} of ${slides.length}`;
        }
        play();
        schedule();
      };
      const updatePause = () => {
        toggle?.setAttribute('aria-pressed', String(paused));
        toggle?.setAttribute('aria-label', paused ? 'Resume slideshow' : 'Pause slideshow');
        const label = toggle?.querySelector('[data-sf-campaign-pause-label]');
        if (label) label.textContent = paused ? 'Resume' : 'Pause';
        schedule();
      };
      campaign.addEventListener('click', event => {
        const step = event.target.closest('[data-sf-campaign-step]');
        if (step) show(index + Number(step.dataset.sfCampaignStep), true);
        const dot = event.target.closest('[data-sf-campaign-index]');
        if (dot) show(Number(dot.dataset.sfCampaignIndex), true);
        if (event.target.closest('[data-sf-campaign-pause]')) { paused = !paused; updatePause(); }
        if (event.target.closest('deferred-media button,video')) { paused = true; updatePause(); }
      });
      campaign.addEventListener('pointerenter', () => clearTimeout(timer));
      campaign.addEventListener('pointerleave', schedule);
      campaign.addEventListener('focusin', () => clearTimeout(timer));
      campaign.addEventListener('focusout', () => setTimeout(schedule, 0));
      const visibility = () => { if (document.hidden) pauseMedia(campaign); else play(); schedule(); };
      document.addEventListener('visibilitychange', visibility);
      const observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          visible = entry.isIntersecting;
          if (visible) play(); else pauseMedia(campaign);
          schedule();
        }
      }, { threshold: .25 });
      observer.observe(campaign);
      campaign.addEventListener('shopify:block:select', event => {
        const selected = slides.findIndex(slide => slide.dataset.sfSlideBlock === event.detail.blockId);
        if (selected >= 0) { paused = true; show(selected, true); updatePause(); }
      });
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      motion.addEventListener?.('change', () => { pauseMedia(campaign); schedule(); play(); });
      campaign.classList.add('sf-hero-ready');
      show(0);
    }
  }
  function setupProductAutoplay(root){
    for(const product of root.querySelectorAll('[data-sf-product-autoplay="true"]')){
      if(product.dataset.sfAutoplayInitialised)continue;product.dataset.sfAutoplayInitialised='true';
      const media=[...product.querySelectorAll('.product__media-list deferred-media')].find(item=>item.querySelector('template')?.content.querySelector('video,iframe'));if(!media)continue;
      const observer=new IntersectionObserver(entries=>{for(const entry of entries)if(entry.isIntersecting)startMutedMedia(media,true);else pauseMedia(media);},{threshold:.5});observer.observe(media);
    }
  }
  const setTheme=()=>document.documentElement.dataset.theme=document.documentElement.dataset.soflyAppearance||'light';
  setTheme();new MutationObserver(setTheme).observe(document.documentElement,{attributes:true,attributeFilter:['data-sofly-appearance']});
  {
    const config=document.querySelector('#sf-blade-audit-config');
    if(config){const script=document.createElement('script');script.src=config.dataset.script;script.dataset.bladeAuditBase=config.dataset.base;script.dataset.bladeAuditRegistry=config.dataset.registry;script.dataset.bladeAuditContracts=config.dataset.contracts;script.dataset.bladeAuditConsumer=config.dataset.consumer;document.body.append(script);}
  }
  initialise();
  document.addEventListener('shopify:section:load',e=>initialise(e.target));
})();
